import setupTrackingLib from './setupTrackingLib';
import setupCustomMetrics from './setupCustomMetrics';

(function initTracking() {
  setupTrackingLib();
  setupCustomMetrics();
})();
